import { AiOutlineTwitter } from "react-icons/ai";
import { BsYoutube } from "react-icons/bs";
import { FaFacebookF } from "react-icons/fa";
import { FaLinkedin } from "react-icons/fa";

export const determineLink = [
	{
		id: 1,
		path: "spend",
		text: "How much i should spend on electricity?",
	},
	{
		id: 2,
		path: "purchase",
		text: "How long my purchased unit will last?",
	},
];

export const terms = [
	{
		id: 1,
		text: "Terms of service",
	},
	{
		id: 2,
		text: "Privacy policy",
	},
	{
		id: 3,
		text: "Test API",
	},
	{
		id: 4,
		text: "Documentation",
	},
];

export const socialIcon = [
	{
		id: 1,
		icon: <AiOutlineTwitter />,
		link: "https://twitter.com/_daveworld",
	},
	{
		id: 2,
		icon: <BsYoutube />,
		link: "https://www.youtube.com/channel/UCLkRxSg9D1YPUEev8gbemoA/videos",
	},
	{
		id: 3,
		icon: <FaFacebookF />,
		link: "https://web.facebook.com/eniola.ademola.1610/",
	},
	{
		id: 4,
		icon: <FaLinkedin />,
		link: "https://www.linkedin.com/in/eniola-ademola",
	},
];
